import { Component, JSX, Show } from 'solid-js';
import { Icon } from '@tcweb/connect-ui';

interface AnchorIconProps {
  anchorIcon: string | JSX.Element;
  size?: 'small' | 'medium';
}

export const AnchorIcon: Component<AnchorIconProps> = (props) => (
  <Show when={typeof props.anchorIcon === 'string'} fallback={props.anchorIcon}>
    <Icon
      icon={props.anchorIcon as string}
      size={props.size === 'medium' ? 'icon-medium' : 'icon-small'}
    />
  </Show>
);
